export const FIELD_IS_REQUIRED = 'Field is required';
export const FIELD_FIRST_NAME_BIDINGFIELD = 'PersonalDetails.FirstName';
export const FIELD_LAST_NAME_BIDINGFIELD = 'PersonalDetails.LastName';
export const MAX_TEXT_LENGTH_FORBIDINGFIELDS = 256;
export const MAX_TEXT_LENGTH = 800;
